module.exports = __webpack_public_path__ + "img/just_logo_blue.dc1677af.svg";